import * as React from 'react';
import * as _ from 'lodash';
import { cleanProps } from '../../utilities/props';
export default function (props, context) {
    return React.createElement('div', { 'className': 'app-content-header app-content-header--with-button app-content-header--lined' }, React.createElement('button', {
        'className': 'ui-button--add ui-button ui-button--green',
        'onClick': props.showAddNewPresetPopup
    }, React.createElement('span', { 'className': 'ui-button-icon ui-button-icon--add' }), React.createElement('span', { 'className': 'ui-button-text' }, 'Add Feature Inclusion')));
}